<template>
    <div class="form-group">
        <label><b>Ora di avvio</b></label>
        <input type="number" class="form-control" v-model="localValue.startingHour" />
    </div>
</template>

<script lang="ts">
import { mixins, Options, Vue } from 'vue-class-component';
import * as OM from '@/model';
import WithModel from '@/mixins/withModel';

@Options({})
export default class triggerConfig extends mixins(WithModel) {
    
    declare localValue: OM.TriggerConfiguration;
    
}
</script>
